@use "../../styles/breakpoint.module" as *;

.root {
    grid-column: 1 / -1;
    position: relative;
    width: 100%;
    overflow: hidden;
    background-color: var(--white);
}

// Applied by CirclesPromo JS to itself + preceding siblings up to the nearest BgTransitionSentinel.
// Reduced motion gets neither the transition nor the color change — the section
// stays its default (white) background.
@media (prefers-reduced-motion: no-preference) {
    :global([data-bg-transition-target]) {
        transition: background-color 2s cubic-bezier(0.16, 1, 0.3, 1);
    }

    :global([data-bg-transition-target][data-bg-transition-active]) {
        background-color: var(--destination-bg);
    }
}

.imageGrid {
    display: grid;
    grid-template-columns: repeat(5, var(--card-width));
    gap: var(--spacer-16);
    justify-content: center;

    --card-width: max(20vw, 303px);

    @media ($below-tablet) {
        --card-width: max(20vw, 219px);
    }

    @media ($below-mobile) {
        --card-width: max(20vw, 103px);

        gap: var(--spacer-8);
    }
}

.column {
    display: flex;
    flex-direction: column;
    gap: var(--spacer-16);
    justify-content: center;
    will-change: transform;
}

.imageCard {
    border-radius: var(--border-radius-md);
    overflow: hidden;
    aspect-ratio: 3 / 4;
    flex-shrink: 0;

    img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        display: block;
    }
}

.textBlock {
    composes: grid from "../../styles/layout.module.scss";
    position: relative;
    text-align: center;
    padding-bottom: var(--spacer-104);
    margin-top: calc(var(--spacer-40) * -1);

    > * {
        grid-column: col-start 3 / span 8;
        justify-self: center;

        @media ($below-tablet) {
            grid-column: col-start 2 / col-end 11;
        }

        @media ($below-mobile) {
            grid-column: content;
        }
    }

    @media ($below-tablet) {
        padding-bottom: var(--spacer-80);
        margin-top: calc(-1 * var(--spacer-32));
    }

    @media ($below-mobile) {
        padding-bottom: var(--spacer-56);
        margin-top: calc(-1 * var(--spacer-24));
    }
}

.headline {
    composes: fontHAI200 from "../../styles/typography.module.scss";

    @media ($below-mobile) {
        font: var(--font-ha-120-md);
        font-style: italic;
    }
}

.subhead {
    composes: fontSH40 from "../../styles/typography.module.scss";
    margin-bottom: var(--spacer-24);
}
